export interface MessageFeedContextInput {
  readonly clearUnreadDivider: () => void;
  readonly currentChannel: unknown;
  readonly currentChannelBreadcrumbs: readonly unknown[];
  readonly getIsOlderPaginationPending: () => boolean;
  readonly handleOpenFullMessageModal: (message: unknown) => void;
  readonly handleOpenImageLightbox: (payload: unknown) => void;
  readonly isDebugEnabled: boolean;
  readonly isInteractive: boolean;
  readonly isSharedChannel?: boolean;
  readonly profileId: string | null;
  readonly unreadDividerSortOrder: string | null;
}

export interface MessageFeedItemContext {
  readonly clearUnreadDivider: () => void;
  readonly currentChannel: unknown;
  readonly currentChannelBreadcrumbs: readonly unknown[];
  readonly handleOpenFullMessageModal: (message: unknown) => void;
  readonly handleOpenImageLightbox: (payload: unknown) => void;
  readonly isDebugEnabled: boolean;
  readonly isInteractive: boolean;
  readonly isSharedChannel: boolean;
  readonly isOlderPaginationPending: boolean;
  readonly profileId: string | null;
  readonly unreadDividerSortOrder: string | null;
}

/** Assembles the legacy MessageListItem context from engine/session state. */
export function buildMessageFeedItemContext(input: MessageFeedContextInput): MessageFeedItemContext {
  return {
    currentChannel: input.currentChannel,
    currentChannelBreadcrumbs: input.currentChannelBreadcrumbs,
    isInteractive: input.isInteractive,
    isDebugEnabled: input.isDebugEnabled,
    isSharedChannel: Boolean(input.isSharedChannel),
    handleOpenFullMessageModal: input.handleOpenFullMessageModal,
    handleOpenImageLightbox: input.handleOpenImageLightbox,
    unreadDividerSortOrder: input.unreadDividerSortOrder,
    clearUnreadDivider: input.clearUnreadDivider,
    profileId: input.profileId,
    get isOlderPaginationPending() {
      return input.getIsOlderPaginationPending();
    }
  };
}
